import { useEffect } from 'react'


export const useBeforeUnload = (prevent: boolean, text: string) => {
  useEffect(() => {
    if (!prevent) {
      return
    }

    const handler = (event: BeforeUnloadEvent) => {
      event.returnValue = text
    }
    window.addEventListener('beforeunload', handler)

    return () => {
      window.removeEventListener('beforeunload', handler)
    }
  }, [prevent, text])
}
